import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "premiere"
}
const _hoisted_2 = {
  key: 0,
  class: "premiere__background"
}
const _hoisted_3 = { class: "premiere__background__container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "premiere__background__container__gradient" }, null, -1)
const _hoisted_6 = { class: "premiere__content" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = {
  key: 0,
  class: "mb-sm text-lg color-accent-base"
}
const _hoisted_9 = { class: "mt-none mb-sm text-3xl text-7xl@sm font-weight-bold" }
const _hoisted_10 = { class: "mb-sm text-lg text-3xl@sm" }
const _hoisted_11 = { class: "mb-sm" }
const _hoisted_12 = { class: "d-none@sm ml-sm mb-xl" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "inline-md@sm"
}
const _hoisted_15 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_16 = {
  key: 0,
  class: "mr-sm mt-md w-full"
}
const _hoisted_17 = {
  key: 1,
  class: "mt-md"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "my-2xl" }
const _hoisted_20 = { class: "text-4xl mb-md font-weight-bold" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-column flex-row@lg"
}
const _hoisted_22 = { class: "text-lg mb-md pr-md" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "my-2xl" }
const _hoisted_26 = { class: "text-4xl mb-md font-weight-bold" }
const _hoisted_27 = { class: "d-flex flex-column flex-row@lg" }
const _hoisted_28 = { class: "text-lg mb-md pr-md" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_31 = { class: "my-2xl" }
const _hoisted_32 = { class: "text-4xl mb-md font-weight-bold" }
const _hoisted_33 = { class: "d-flex flex-column flex-row@lg" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ImagePoster = _resolveComponent("ImagePoster")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Row = _resolveComponent("Row")!
  const _component_WatchButton = _resolveComponent("WatchButton")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_RelatedArticles = _resolveComponent("RelatedArticles")!
  const _component_TrailerModal = _resolveComponent("TrailerModal")!

  return (_openBlock(), _createElementBlock("div", { key: _ctx.slug }, [
    (_ctx.requestStateMedia.status === 'loading' || _ctx.isFetchingAuthUser)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : (_ctx.requestStateMedia.status === 'ready' && _ctx.media)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.media.poster)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      class: "premiere__background__container__img",
                      src: 
              _ctx.imageUrlBuilder
                .image(_ctx.media.poster)
                .width(60)
                .blur(60)
                .auto('format')
                .url()
            
                    }, null, 8, _hoisted_4),
                    _hoisted_5
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Grid, { size: "lg" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Row, { gap: "xl" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Col, {
                        size: ['4/12@sm', '3/12@lg'],
                        class: "d-none@xs d-flex@sm"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.media.poster)
                            ? (_openBlock(), _createBlock(_component_ImagePoster, {
                                key: 0,
                                image: _ctx.media.poster,
                                type: _ctx.media.type,
                                class: "premiere__poster"
                              }, null, 8, ["image", "type"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Col, {
                        size: ['12/12', '8/12@sm', '9/12@lg'],
                        class: "d-flex flex-column justify-content-end"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", null, [
                              (_ctx.media.premierDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.trans("general.premiere_on")) + " " + _toDisplayString(_ctx.formatDateLong(_ctx.media.premierDate / 1000, "es", true)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.media.title), 1),
                              _createElementVNode("div", _hoisted_10, [
                                (_ctx.media.directors?.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.media.directors.join(", ")), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.media.genres?.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(" · " + _toDisplayString(_ctx.media.genres.join(", ")), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                (_ctx.media.originalTitle)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.media.originalTitle) + " · ", 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.media.year)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.media.year), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.media.countries?.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(" · " + _toDisplayString(_ctx.media.countries.join(", ")), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              (_ctx.media.poster)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "rounded-xl",
                                    src: 
                      _ctx.imageUrlBuilder
                        .image(_ctx.media.poster)
                        .width(100)
                        .auto('format')
                        .url()
                    
                                  }, null, 8, _hoisted_13))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.media.playerUrl || _ctx.media.trailerUrl || _ctx.media.assetsUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_ctx.media.playerUrl || _ctx.media.trailerUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      (_ctx.media.trailerUrl)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createVNode(_component_Button, {
                                              text: _ctx.trans('general.watch_trailer'),
                                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isTrailerModalOpen = true)),
                                              size: "lg",
                                              class: "w-full"
                                            }, null, 8, ["text"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.media.playerUrl)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createVNode(_component_Button, {
                                              text: _ctx.trans('general.details_in_filmin'),
                                              href: _ctx.media.playerUrl,
                                              size: "lg",
                                              class: "w-full"
                                            }, null, 8, ["text", "href"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Row, { gap: "xl" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Col, {
                        size: ['4/12@sm', '3/12@lg'],
                        class: "d-none@xs d-flex@sm"
                      }),
                      _createVNode(_component_Col, null, {
                        default: _withCtx(() => [
                          (!_ctx.authUser)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_18,
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.trans("general.exclusive_journalists")), 1),
                                  (!_ctx.authUser)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.trans("general.get_access_and_more_information")), 1),
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_Button, {
                                            text: _ctx.trans('general.press_access'),
                                            isOutline: "",
                                            to: {
                          name: 'Access',
                          query: {
                            r: _ctx.currentUrl,
                          },
                        },
                                            size: "lg"
                                          }, null, 8, ["text", "to"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _hoisted_23
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.authUser && !_ctx.authUser.pressMediasIds)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_24,
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.trans("general.exclusive_journalists")), 1),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.trans("general.your_user_does_not_have_permissions")), 1),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_Button, {
                                        text: _ctx.trans('general.request_permits'),
                                        isOutline: "",
                                        to: {
                          name: 'Access',
                          query: {
                            r: _ctx.currentUrl,
                          },
                        },
                                        size: "lg"
                                      }, null, 8, ["text", "to"])
                                    ])
                                  ])
                                ]),
                                _hoisted_29
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                  (_ctx.authUser && _ctx.authUser.pressMediasIds) ||
                  (_ctx.authUser && _ctx.media.assetsUrl)
                )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_30,
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.trans("general.exclusive_journalists")), 1),
                                  _createElementVNode("div", _hoisted_33, [
                                    (_ctx.media.mediaId)
                                      ? (_openBlock(), _createBlock(_component_WatchButton, {
                                          key: 0,
                                          mediaId: _ctx.media.mediaId
                                        }, null, 8, ["mediaId"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.media.assetsUrl)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 1,
                                          text: _ctx.trans('general.download_resources'),
                                          href: _ctx.media.assetsUrl,
                                          target: "_blank",
                                          class: "mt-md",
                                          size: "xl"
                                        }, null, 8, ["text", "href"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _hoisted_34
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.media.body)
                            ? (_openBlock(), _createBlock(_component_RichText, {
                                key: 3,
                                blocks: _ctx.media.body,
                                gridSize: "none"
                              }, null, 8, ["blocks"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            (_ctx.media.articles?.length)
              ? (_openBlock(), _createBlock(_component_RelatedArticles, {
                  key: 1,
                  class: "p-relative",
                  articles: _ctx.media.articles
                }, null, 8, ["articles"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    (_ctx.isTrailerModalOpen && _ctx.media.trailerUrl)
      ? (_openBlock(), _createBlock(_component_TrailerModal, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isTrailerModalOpen = false)),
          src: _ctx.normalizedTrailerUrl
        }, null, 8, ["src"]))
      : _createCommentVNode("", true)
  ]))
}